
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS_FORMDATA, HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import * as SectionTemplateAction from './action';
import { REPORT } from '../../../config';


export function* sectionTemplateCreate(action) {
    let formData = new FormData()
    formData.append('sectionName', action.data.sectionTemplateName);
    formData.append('reportDisplayName', action.data.reportDisplayName);
    formData.append('sectionType', action.data.sectionType);
    formData.append('sectionDataTableType', action.data.keys);
    formData.append('file', action.data.file);
    formData.append('apiKeyName', action.data.apiKeyName);
    formData.append('tags', action.data.tags);
    formData.append('analystVisible', action.data.analystVisible)
    let requestUrl = `${REPORT}/section/excel/add`;
    try {
        const createResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(SectionTemplateAction.sectionTemplateSuccess(createResult));
    } catch (err) {
        yield put(SectionTemplateAction.sectionTemplateError(err))
    }
}
export function* setSectionTemplate() {
    yield takeLatest(SectionTemplateAction.SECTION_TEMPLATE_DATA, sectionTemplateCreate);
}
export function* sectionTemplateEdit(action) {
    let formData = new FormData()
    formData.append('id', action.data.id);
    formData.append('sectionName', action.data.sectionTemplateName);
    formData.append('reportDisplayName', action.data.reportDisplayName);
    formData.append('sectionType', action.data.sectionType);
    formData.append('sectionDataTableType', action.data.keys);
    formData.append('apiKeyName', action.data.apiKeyName);
    formData.append('file', action.data.file);
    formData.append('tags', action.data.tags)
    formData.append('analystVisible', action.data.analystVisible)
    let requestUrl = `${REPORT}/section/excel/edit`;
    try {
        const editResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(SectionTemplateAction.sectionTemplateSuccess(editResult));
    } catch (err) {
        yield put(SectionTemplateAction.sectionTemplateError(err))
    }
}
export function* setSectionTemplateEdit() {
    yield takeLatest(SectionTemplateAction.SECTION_TEMPLATE_EDIT_DATA, sectionTemplateEdit);
}

export function* getSectionTemplateConfig(action) {

    let requestUrl = `${REPORT}/section/tabletype/list`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(SectionTemplateAction.sectionTemplateConfigSuccess(result.data));
    } catch (err) {
        yield put(SectionTemplateAction.sectionTemplateConfigError({
            "List of items": "OBJECT_LIST",
            "Financial Data Value": "VERTICAL_KEY_VALUE",
            "Key-Value Pair (3 columns)": "HORIZONTAL_KEY_VALUE_WITH_HEADER",
            "No Computable Excel table objects": "NONE",
            "Simple Key-Value Pair (2 columns)": "HORIZONTAL_KEY_VALUE"
        }))
    }
}
export function* sectionTemplateConfig() {
    yield takeLatest(SectionTemplateAction.SECTION_TEMPLATE_CONFIGURATION, getSectionTemplateConfig);
}

export function* sectionTemplateTypeList(action) {
    let requestUrl = `${REPORT}/section/type/list`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(SectionTemplateAction.sectionTemplateTypeSuccess(result.data));
    } catch (err) {
        yield put(SectionTemplateAction.sectionTemplateTypeError({
            "System-Defined Section": "SYSTEMDEFINED",
            "Financial Section": "FINANCIAL",
            "Predefined Section": "PREDEFINED",
            "Computable Section - with Excel Table Objects": "DATA"

        }))
    }
}
export function* sectionTemplateType() {
    yield takeLatest(SectionTemplateAction.SECTION_TEMPLATE_TYPE, sectionTemplateTypeList);
}

export function* templateMapping(action) {
    let requestUrl = `${REPORT}/section/mapping`;
    try {
        const createResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(SectionTemplateAction.setSectionTemplateMappingSuccess(createResult.data));
    } catch (err) {
        yield put(SectionTemplateAction.setSectionTemplateMappingFailure(err.response))
    }
}
export function* sectionTemplateMapping() {
    yield takeLatest(SectionTemplateAction.SECTION_TEMPLATE_MAPPING, templateMapping);
}

export function* templateMappingEdit(action) {
    let requestUrl = `${REPORT}/section/mapping/edit`;
    if(action.data.type === "API_KEY"){
        requestUrl = `${REPORT}/section/api/mapping/edit`
    }
    try {
        const createResult = yield call(request, requestUrl, { data: action.data.mappingObject, method: 'POST', headers: HTTP_HEADERS });
        yield put(SectionTemplateAction.setSectionTemplateMappingEditSuccess(createResult.data));
    } catch (err) {
        yield put(SectionTemplateAction.setSectionTemplateMappingEditFailure(err.response))
    }
}
export function* sectionTemplateMappingEdit() {
    yield takeLatest(SectionTemplateAction.SECTION_TEMPLATE_MAPPING_EDIT, templateMappingEdit);
}

export function* masterDataValue(action) {
    let requestUrl = `${REPORT}/masterdatakey/keytype/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'get', headers: HTTP_HEADERS });
        yield put(SectionTemplateAction.getMasterDataValueSuccess(createResult.data));
    } catch (err) {
        yield put(SectionTemplateAction.getMasterDataValueFailure(err.response))
    }
}
export function* getmasterDataValue() {
    yield takeLatest(SectionTemplateAction.GET_MASTER_DATA_KEY_VALUES, masterDataValue);
}

export function* updateAPIKeyNameRequest(action) {
    let requestUrl = `${REPORT}/section/api/key-mapping`;
    let formData = new FormData()
    formData.append('sectionTemplateId', action.data.sectionTemplateId);
    formData.append('apiKeyName', action.data.apiKeyName)

    try {
        const result = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(SectionTemplateAction.updateAPIKeyNameResponse({...result.data, status : "SUCCESS"}));
    } catch (err) {
        yield put(SectionTemplateAction.updateAPIKeyNameResponse(err.response))
    }
}

export function* updateAPIKeyName() {
    yield takeLatest(SectionTemplateAction.UPDATE_API_KEY_NAME_OF_SECTION_TEMPLATE_REQUEST, updateAPIKeyNameRequest);
}